export default __webpack_public_path__ + "static/media/profile.c0624c8a.png";